import request from './request'

export interface SettlementConfig {
  essential_care?: {
    type: string
    value: number
  }
  enhanced_care?: {
    type: string
    value: number
  }
  premium_care?: {
    type: string
    value: number
  }
  follow_up_care?: {
    type: string
    value: number
  }
  add_on_service?: {
    type: string
    value: number
  }
}

export interface CreateTechnicianParams {
  name: string
  phone_code: string
  phone: string
  avatar?: string
  work_role: string
  license_no?: string
  sin_type?: string
  sin_number?: string
  residency_status?: string
  address?: string
  email?: string
  settlement_config?: SettlementConfig
}

// ✅ 编辑参数和新建完全一致，只多了id
export interface UpdateTechnicianParams extends CreateTechnicianParams {
  id: number
}

export interface TechnicianOrderStats {
  hmac_orders: number
  fu_orders: number
  ad_orders: number
}

export interface TechnicianItem {
  id: number
  technician_no: string
  name: string
  avatar: string
  phone_code: string
  phone: string
  mobile: string
  work_role: string
  license_no: string
  sin_type: string
  sin_number: string
  residency_status: string
  address: string
  email: string
  status: number
  status_text: string
  settlement_config: SettlementConfig
  order_stats: TechnicianOrderStats
  upcoming_service: string | null
  create_time: string
  update_time: string
}

export interface CreateTechnicianResponse {
  code: number
  msg: string
  data: {
    list: TechnicianItem[]
    pagination: {
      page: number
      page_size: number
      total: number
      total_pages: number
    }
  }
}

// ✅ 编辑响应和新建完全一致
export interface UpdateTechnicianResponse extends CreateTechnicianResponse {}

// ✅ 新建接口（你说能正常工作的）
export async function createTechnician(data: CreateTechnicianParams) {
  return request.post<CreateTechnicianResponse>('/api/admin/technician/create', data)
}

// ✅ 编辑接口：和新建完全一样的路径格式，只改了接口名
export async function updateTechnician(data: UpdateTechnicianParams) {
  return request.post<UpdateTechnicianResponse>('/api/admin/technician/update', data)
}
